export const LANGUAGES = {
  english: 'en',
  spanish: 'es'
}
